import { useContext, useEffect, useState } from "react";
import { EnterpriseContext } from "../../components/enterprise/EnterpriseContext";
import { DrawerComponent } from "../../common/plugins/metronic/components";
import truckyService from "../../common/services/trucky-service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";
import { useLocation, useNavigate } from "react-router";
import EnterpriseService from "../../common/services/enterprise-service";
import config from "../../config";
import { Button, Input, InputGroup } from "reactstrap";
import { Link } from "react-router-dom";

const Drawer = ({ container }) => {
  const { globalContext, setGlobalContext } = useContext(EnterpriseContext);
  const navigate = useNavigate();
  const es = new EnterpriseService();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setTimeout(() => DrawerComponent.bootstrap());
  }, []);

  useEffect(() => {
    let instance = DrawerComponent.getInstance("kt_drawer_example_basic");
    if (instance) instance.hide();
  }, [location]);

  const logout = () => {
    truckyService.removeToken();
    setGlobalContext({ user: null, company: null });
    navigate("/");
  };

  const navigateToSearch = () => {
    if (searchTerm !== "" && searchTerm.length >= 3)
      navigate(`/search?term=${searchTerm}`);
  };

  const SectionLabel = ({ label }) => (
    <div className="sidebar-section-label">{label}</div>
  );

  const MenuItem = ({ to, icon, label, onClick, premium }) => (
    <Link
      to={to || "#"}
      onClick={onClick}
      className={classnames("vtc-menu-item", {
        active: location.pathname === to,
      })}
    >
      <span className="vtc-menu-icon">
        <FontAwesomeIcon
          icon={icon}
          fixedWidth
          className={premium ? "text-warning" : ""}
        />
      </span>
      <span
        className={classnames("vtc-menu-title", {
          "text-warning fw-bold": premium,
        })}
      >
        {label}
      </span>
    </Link>
  );

  const isEco =
    globalContext.company != null &&
    (globalContext.company.company_type === "realistic" ||
      globalContext.company.company_type === "both");

  return (
    <div
      id="kt_drawer_example_basic"
      className="mobile-drawer"
      data-kt-drawer="true"
      data-kt-drawer-direction="start"
      data-kt-drawer-activate="true"
      data-kt-drawer-width="300px"
      data-kt-drawer-toggle="#kt_drawer_example_basic_button"
      data-kt-drawer-close="#kt_drawer_example_basic_close"
    >
      {/* Header */}
      <div className="mobile-drawer-header">
        <div className="d-flex align-items-center gap-3">
          <span className="fw-bold fs-5">Trucky HUB</span>
        </div>
        <button
          id="kt_drawer_example_basic_close"
          className="mobile-drawer-close"
        >
          <FontAwesomeIcon icon="times" className="mx-0" />
        </button>
      </div>

      <div className="mobile-drawer-body">
        {/* Search */}
        {/*<div className="mobile-drawer-search">
          <InputGroup size="sm">
            <Input
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={container.localeManager.strings.searchForPlayerName}
              onKeyDown={(e) => e.key === "Enter" ? navigateToSearch() : true}
            />
            <Button color="primary" onClick={navigateToSearch}>
              <FontAwesomeIcon icon="search" className="mx-0" />
            </Button>
          </InputGroup>
        </div>
        */}

        <div className="vtc-menu">
          {/* User profile */}
          {truckyService.getToken() && globalContext.member ? (
            <>
              <div className="mobile-drawer-user">
                <img
                  src={globalContext.member.avatar_url}
                  className="mobile-drawer-avatar"
                  alt={globalContext.member.name}
                />
                <div className="mobile-drawer-user-info">
                  <div className="fw-bold">{globalContext.member.name}</div>
                  <div className="small text-muted">
                    {globalContext.member.email}
                  </div>
                </div>
              </div>

              <SectionLabel
                label={container.localeManager.strings.account || "Account"}
              />
               <MenuItem
                to="/profile/edit"
                icon="user-cog"
                label={container.localeManager.strings.profileSettings}
              />
              <MenuItem
                to="/my/profile"
                icon="user"
                label={container.localeManager.strings.profile}
              />
              <MenuItem
                to="/my/applications"
                icon="file-signature"
                label={container.localeManager.strings.myApplications}
              />
              <MenuItem
                to="/my/subscriptions"
                icon="star"
                label={container.localeManager.strings.subscriptions}
              />
              <button
                onClick={logout}
                className="vtc-menu-item w-100 text-start border-0 bg-transparent text-danger"
              >
                <span className="vtc-menu-icon">
                  <FontAwesomeIcon
                    icon="sign-out"
                    fixedWidth
                    className="text-danger"
                  />
                </span>
                <span className="vtc-menu-title">
                  {container.localeManager.strings.logout}
                </span>
              </button>
            </>
          ) : (
            <Link className="vtc-menu-item mt-2" to="/login">
              <span className="vtc-menu-icon">
                <FontAwesomeIcon icon="user-lock" fixedWidth />
              </span>
              <span className="vtc-menu-title">
                {container.localeManager.strings.login}
              </span>
            </Link>
          )}

          {/* VTC Hub */}
          {globalContext.company != null ? (
            <>
              <SectionLabel label={container.localeManager.strings.vtcHub} />
              <MenuItem
                to="/vtchub"
                icon="home"
                label={container.localeManager.strings.dashboard}
              />
              {es.can(globalContext.member, "company.*") && (
                <MenuItem
                  to="/company/settings"
                  icon="cog"
                  label={container.localeManager.strings.companySettings}
                />
              )}
              <MenuItem
                to="/company/members"
                icon="users"
                label={container.localeManager.strings.members}
              />
              {es.can(globalContext.member, "members.manage_roles") && (
                <MenuItem
                  to="/company/roles"
                  icon="user-shield"
                  label={container.localeManager.strings.roles}
                />
              )}
              {es.can(globalContext.member, "members.manage_roles") && (
                <MenuItem
                  to="/company/ranks"
                  icon="trophy"
                  label={container.localeManager.strings.ranks}
                />
              )}
              {es.can(globalContext.member, "members.manage_applications") && (
                <MenuItem
                  to="/applications"
                  icon="file-signature"
                  label={container.localeManager.strings.applications}
                />
              )}
              <MenuItem
                to="/jobs"
                icon="route"
                label={container.localeManager.strings.jobs}
              />
              <MenuItem
                to="/stats"
                icon="chart-line"
                label={container.localeManager.strings.stats}
              />
              <MenuItem
                to="/company/events/calendar"
                icon="calendar-days"
                label={container.localeManager.strings.calendar}
              />

              {isEco && (
                <>
                  <SectionLabel
                    label={
                      container.localeManager.strings.fleet || "Fleet & Finance"
                    }
                  />
                  <MenuItem
                    to="/balance"
                    icon="wallet"
                    label={container.localeManager.strings.balance}
                  />
                  <MenuItem
                    to="/garages"
                    icon="warehouse"
                    label={container.localeManager.strings.garages}
                  />
                  <MenuItem
                    to="/vehicles"
                    icon="truck"
                    label={container.localeManager.strings.fleet}
                  />
                  <MenuItem
                    to="/maintenances"
                    icon="screwdriver-wrench"
                    label={container.localeManager.strings.maintenance}
                  />
                  <MenuItem
                    to="/market/1"
                    icon="store"
                    label={`${container.localeManager.strings.globalMarket} – EU`}
                  />
                  <MenuItem
                    to="/market/2"
                    icon="store"
                    label={`${container.localeManager.strings.globalMarket} – US`}
                  />
                </>
              )}

              {(es.can(globalContext.member, "events.manage") ||
                es.can(globalContext.member, "feeds.manage") ||
                es.can(globalContext.member, "achievements.manage") ||
                es.can(globalContext.member, "company.*")) && (
                <>
                  <SectionLabel
                    label={container.localeManager.strings.content || "Content"}
                  />
                  {es.can(globalContext.member, "events.manage") && (
                    <MenuItem
                      to="/company/events"
                      icon="calendar-check"
                      label={container.localeManager.strings.events}
                    />
                  )}
                  {es.can(globalContext.member, "feeds.manage") && (
                    <MenuItem
                      to="/feeds/manage"
                      icon="newspaper"
                      label={container.localeManager.strings.newsFeed}
                    />
                  )}
                  {es.can(globalContext.member, "achievements.manage") && (
                    <MenuItem
                      to="/company/achievements"
                      icon="trophy"
                      label={container.localeManager.strings.achievements}
                    />
                  )}
                  {es.can(globalContext.member, "company.*") && (
                    <MenuItem
                      to="/company/logs"
                      icon="clipboard-list"
                      label={container.localeManager.strings.logs}
                    />
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <SectionLabel label={container.localeManager.strings.vtcHub} />
              <MenuItem
                to="/register-your-company"
                icon="building"
                label={container.localeManager.strings.registerYourCompany}
              />
            </>
          )}

          {/* Site navigation */}
          <SectionLabel label="Trucky HUB" />
          <MenuItem
            to="/directory"
            icon="database"
            label={container.localeManager.strings.vtcDirectory}
          />
           <MenuItem
            to="/events"
            icon="calendar-days"
            label={container.localeManager.strings.events}
          />
          <MenuItem
            to="/hosting"
            icon="server"
            label={container.localeManager.strings.dedicatedServers}
          />
          <SectionLabel label={container.localeManager.strings.leaderboards} />
          <MenuItem
            to="/leaderboards/companies/distance"
            icon="road"
            label={`${container.localeManager.strings.companies} — ${container.localeManager.strings.realMiles || "Distance"}`}
          />
          <MenuItem
            to="/leaderboards/companies/hardcore"
            icon="shield-halved"
            label={`${container.localeManager.strings.companies} — ${container.localeManager.strings.hardcoreSimulation || "Hardcore"}`}
          />
          <MenuItem
            to="/leaderboards/users/distance"
            icon="road"
            label={`${container.localeManager.strings.users || "Users"} — ${container.localeManager.strings.realMiles || "Distance"}`}
          />
          <MenuItem
            to="/leaderboards/users/hardcore"
            icon="shield-halved"
            label={`${container.localeManager.strings.users || "Users"} — ${container.localeManager.strings.hardcoreSimulation || "Hardcore"}`}
          />
         

          <SectionLabel label="TruckersMP" />
          <MenuItem
            to="/servers"
            icon="server"
            label={container.localeManager.strings.routeServersTitle}
          />
          <MenuItem
            to="/traffic"
            icon="traffic-light"
            label={container.localeManager.strings.traffic}
          />
          <MenuItem
            to="/map"
            icon="map"
            label={container.localeManager.strings.map}
          />

          {/* Premium */}
          {!container.dataService.data.enablePremiumFeature() && (
            <div className="mt-4 px-2">
              <Link
                to="/premium"
                className="footer-premium-cta w-100 justify-content-center"
              >
                <FontAwesomeIcon icon="star" className="mx-0" />
                Go Premium
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Drawer;
